var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cabins-guests cabins-guests--preview",
      attrs: { id: "guests" },
    },
    [
      _c("div", { staticClass: "cabins-guests__header" }, [
        _vm._v("Проверьте правильность заполненной информации"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cabins-guests__content" }, [
        _c(
          "div",
          { staticClass: "cabins-guests__section" },
          _vm._l(
            _setup.cstore.getCabins,
            function ({ id, Cabin, CabinSet, places, ages }) {
              return _c(
                "div",
                { key: id, staticClass: "cabin" },
                [
                  _c(
                    "div",
                    { staticClass: "cabin__wrapper" },
                    [
                      _c("div", { staticClass: "cabin__header cabin-header" }, [
                        _c("div", { staticClass: "cabin-header__content" }, [
                          _c("div", { staticClass: "cabin-header__title" }, [
                            _vm._v(
                              _vm._s(
                                /^\d+$/.test(Cabin.name)
                                  ? `Каюта ${Cabin.name}`
                                  : Cabin.name
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cabin-header__deck" }, [
                            _vm._v(
                              _vm._s(
                                /палуба/i.test(Cabin.deck.name)
                                  ? Cabin.deck.name
                                  : `${Cabin.deck.name} палуба`
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "cabin__content cabin-content" },
                        [
                          _vm._l(places, function (place) {
                            return [
                              _c(_setup.FillPlacePreview, {
                                key: place.pnum,
                                staticClass: "cabin-content__place",
                                attrs: {
                                  place: place,
                                  cabinId: id,
                                  Cabin: Cabin,
                                  ages: ages,
                                  viewMode: "full",
                                  validationMode: "strict",
                                },
                              }),
                            ]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(_setup.CabinPrice, {
                        staticClass: "cabin__footer cabin-footer",
                        attrs: {
                          precalc: _setup.bookPrecalc,
                          cabinId: id,
                          childClass: "cabin-footer",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(_setup.CabinErrors, {
                    attrs: { errors: _setup.cabinErrors[id], double: true },
                  }),
                ],
                1
              )
            }
          ),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "cabins-guests__section" }, [
          _c(
            "div",
            { staticClass: "cabin" },
            [
              _c(
                "div",
                { staticClass: "cabin__wrapper" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cabin__content cabin-content" },
                    [
                      _c(_setup.FillPlacePreview, {
                        staticClass: "cabin__persons__place",
                        attrs: {
                          place: _setup.bookCabins.customerCabinPlace,
                          cabinId: _setup.bookCabins.customerCabinId,
                          viewMode: "full",
                          validationMode: "strict",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _setup.cstore.getCabins.length > 1
                    ? _c(_setup.CabinPrice, {
                        staticClass: "cabin__footer cabin-footer",
                        attrs: {
                          precalc: _setup.bookPrecalc,
                          sum: true,
                          childClass: "cabin-footer",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(_setup.CabinErrors, {
                attrs: {
                  errors: _setup.cabinErrors[_setup.cuCabin],
                  double: true,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cabin", staticStyle: { "grid-column": "span 2" } },
            [
              _c("div", { staticClass: "cabin__wrapper" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "cabin__content cabin-content" }, [
                  _c("div", { staticClass: "cabin-content__comment" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.bookCabins.notes_note,
                          expression: "bookCabins.notes_note",
                        },
                      ],
                      attrs: { placeholder: "Ваш комментарий к заказу" },
                      domProps: { value: _setup.bookCabins.notes_note },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _setup.bookCabins,
                            "notes_note",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cabin-content__checkbox-options" },
                    [
                      _c(
                        _setup.MyCheckbox,
                        {
                          attrs: { choosed: _setup.bookCabins.notes_attachDoc },
                          on: {
                            input: function ($event) {
                              _setup.bookCabins.notes_attachDoc = $event
                            },
                          },
                        },
                        [_c("span", [_vm._v("Пенсионная скидка")])]
                      ),
                      _vm._v(" "),
                      _setup.bookCabins.notes_attachDoc
                        ? _c("div", [
                            _vm._v(
                              "Для подтверждения скидки прикрепите пенсионное удостоверение после сохранения заявки"
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "cabin__header cabin-header" }, [
      _c("div", { staticClass: "cabin-header__content" }, [
        _c("div", { staticClass: "cabin-header__title" }, [_vm._v("Заказчик")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "cabin__header cabin-header" }, [
      _c("div", { staticClass: "cabin-header__content" }, [
        _c("div", { staticClass: "cabin-header__title" }, [
          _vm._v("Комментарии и скидки"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }